/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * @hidden
 */
export var ModelTypes_$type = /*@__PURE__*/ markEnum('ModelTypes', 'ColumnHeader,0|Cell,1|SectionHeader,2|SectionFooter,3|RowSeparator,4|VerticalSeparator,5|ResizeSeparator,6');
//# sourceMappingURL=ModelTypes.js.map
